import * as React from 'react';
import { SVGProps } from 'react';

const IconDinosaurSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 1H9v1H8v4H6v1H5v1H4v1H3V8H2V6H1v3.5h1v1h1v1h1v1h1V15h2v-1H6v-1h.5v-1h1v1H8v2h2v-1H9v-2.5h.5V10h1V8h1v1h1V7H10V6h3V5h-2V4h4V2h-1V1zm-2 1h-1v1h1V2z"
    />
  </svg>
);
export default IconDinosaurSizeS;
